module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.messageModalDisplayed,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), (!_vm.selectImageMode) ? _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("New Notification")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.selectImageMode),
      expression: "!selectImageMode"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', {
    staticClass: "btn blue btn-outline",
    class: {
      'active': _vm.message.notification_type === 'push'
    },
    attrs: {
      "for": "push_notification"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.notification_type),
      expression: "message.notification_type"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "radio",
      "id": "push_notification",
      "value": "push"
    },
    domProps: {
      "checked": _vm._q(_vm.message.notification_type, "push")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "notification_type", "push")
      }
    }
  }), _vm._v("\n\t\t\t\t\t\tPush Notification\n\t\t\t\t\t")]), _vm._v(" "), _c('label', {
    staticClass: "btn blue btn-outline",
    class: {
      'active': _vm.message.notification_type === 'inapp'
    },
    attrs: {
      "for": "inapp_notification"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.notification_type),
      expression: "message.notification_type"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "radio",
      "id": "inapp_notification",
      "value": "inapp"
    },
    domProps: {
      "checked": _vm._q(_vm.message.notification_type, "inapp")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "notification_type", "inapp")
      }
    }
  }), _vm._v("\n\t\t\t\t\t\tIn App Notification\n\t\t\t\t\t")]), _vm._v(" "), _c('label', {
    staticClass: "btn blue btn-outline",
    class: {
      'active': _vm.message.notification_type === 'sms'
    },
    attrs: {
      "for": "sms_notification"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.notification_type),
      expression: "message.notification_type"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "radio",
      "id": "sms_notification",
      "value": "sms"
    },
    domProps: {
      "checked": _vm._q(_vm.message.notification_type, "sms")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "notification_type", "sms")
      }
    }
  }), _vm._v("\n\t\t\t\t\t\tSMS\n\t\t\t\t\t")])])]), _vm._v(" "), (_vm.message.notification_type === 'inapp') ? _c('div', {
    class: {
      'col-xs-4 col-xs-offset-4': !_vm.selectImageMode, 'col-xs-12': _vm.selectImageMode
    }
  }, [_c('resource-picker', {
    staticClass: "margin-top-15",
    attrs: {
      "imageButton": true,
      "imageUrl": _vm.message.media_path
    },
    on: {
      "open": function($event) {
        _vm.toggleImageMode('newMenu', true)
      },
      "close": function($event) {
        _vm.toggleImageMode('newMenu', false)
      },
      "selected": _vm.updateImage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.selectImageMode),
      expression: "!selectImageMode"
    }],
    staticClass: "col-xs-12"
  }, [(_vm.message.notification_type === 'push') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.title),
      expression: "message.title"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.message.title.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.message.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Title")])]) : _vm._e(), _vm._v(" "), (_vm.message.notification_type === 'push') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.message),
      expression: "message.message"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.message.message.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.message.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Message")])]) : _vm._e(), _vm._v(" "), (_vm.message.notification_type === 'inapp') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.title),
      expression: "message.title"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.message.title.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.message.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Title")])]) : _vm._e(), _vm._v(" "), (_vm.message.notification_type === 'inapp') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.push_message),
      expression: "message.push_message"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.message.push_message.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.message.push_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "push_message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Push message")])]) : _vm._e(), _vm._v(" "), (_vm.message.notification_type === 'inapp') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.message),
      expression: "message.message"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.message.message.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_5"
    },
    domProps: {
      "value": (_vm.message.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_5"
    }
  }, [_vm._v("Body")])]) : _vm._e(), _vm._v(" "), (_vm.message.notification_type === 'push') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "placeholder": "Expires on"
    },
    model: {
      value: (_vm.message.expire_at),
      callback: function($$v) {
        _vm.$set(_vm.message, "expire_at", $$v)
      },
      expression: "message.expire_at"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.message.notification_type === 'inapp') ? _c('el-dropdown', {
    staticClass: "margin-top-15",
    attrs: {
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateCallToAction
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.selectedCallLabel) + "\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": 17
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCall\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": 14
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tWebsite\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": 13
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tClose\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": 15
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCamera\n\t\t\t\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.message.call_to_action === 'CALL' || _vm.message.call_to_action === 'GOTO_LINK') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.action_value),
      expression: "message.action_value"
    }],
    staticClass: "form-control input-sm edited",
    attrs: {
      "type": "text",
      "id": "form_control_6"
    },
    domProps: {
      "value": (_vm.message.action_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "action_value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_6"
    }
  }, [_vm._v(_vm._s(_vm.numberOrUrl))])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.selectImageMode && _vm.message.notification_type.length) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.sendMessage()
      }
    }
  }, [_vm._v("Send")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d51f7d2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UserManager/Message.vue
// module id = 783
// module chunks = 0